import { put, call } from 'redux-saga/effects';
import { Types } from './actions';
import CourseRepository from '@/domain/repositories/CourseRepository';
import CourseDataRepository from '@/data/repositories/CourseDataRepository';

export default function* execute(action: any): any {
  try {
    yield put({
      type: Types.GET_COURSE_SUMMARY_CLEAR
    });
    const { periodId } = action;
    yield put({ type: Types.GET_COURSE_SUMMARY_REQUEST });
    const courseRepository: CourseRepository = new CourseDataRepository();
    const courseResponseSummary = yield call(
      courseRepository.getCourseSummary,
      periodId
    );
    yield put({
      type: Types.GET_COURSE_SUMMARY_SUCCESS,
      data: courseResponseSummary.getCourseSummary
    });
  } catch (error) {
    yield put({
      type: Types.GET_COURSE_SUMMARY_FAILURE,
      error: 'Ocurrió un error al momento de leer los datos del estudiante.'
    });
  }
}
